import { FC, useContext, useState } from 'react';
import { Icon, IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import GlobalContext from '../../contexts/GlobalContext';
import { useTheme } from '@mui/material';

type TPasswordInputProps = Omit<TextFieldProps, 'type' | 'fullWidth' | 'InputProps'> & {
    onShowPassword?: () => void;
    onHidePassword?: () => void;
};
const PasswordInput: FC<TPasswordInputProps> = (props) => {
    const { language } = useContext(GlobalContext);
    const { onShowPassword, onHidePassword, ...remainingProps } = props;
    const [showPassword, setShowPassword] = useState(false);
    const theme = useTheme();
    const handleShowPasswordToggle = () => {
        if (showPassword) {
            onHidePassword && onHidePassword();
        } else {
            onShowPassword && onShowPassword();
        }
        setShowPassword(!showPassword);
    };
    return (
        <TextField
            data-testid="password-input"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={handleShowPasswordToggle}
                            data-testid="password-input-toggle"
                            edge="end"
                            sx={{ color: theme.palette.action.active }}
                        >
                            {showPassword ? (
                                <Icon aria-label={language.common.hide}>visibility_off</Icon>
                            ) : (
                                <Icon aria-label={language.common.show}>visibility_on</Icon>
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...remainingProps}
        />
    );
};

export default PasswordInput;
